module.exports = __webpack_public_path__ + "img/Porto Apartment - 70 of 85.c892b2e8.jpeg";